export default __webpack_public_path__ + "static/media/prime-img.8c29f56a.png";